import { Divider } from "antd";
import { twMerge } from "tailwind-merge";
import SidebarItem from "./sidebar-item";
import HamburgerIcon from "../icons/hamburger-icon";
import { ROUTE_PATHS } from "../config/constants";
import {
  FileProtectOutlined,
  GlobalOutlined,
  LineChartOutlined,
  PieChartOutlined,
  RiseOutlined,
} from "@ant-design/icons";

const Sidebar = ({ toggleSidebar, isSidebarOpen, setIsSidebarOpen }) => {
  const adminItems = [
    {
      label: "Якунланган лойихалар",
      icon: LineChartOutlined,
      path: ROUTE_PATHS.DASHBOARD1,
      status: "in progress",
    },
    {
      label: "Инвестиция дастури",
      icon: FileProtectOutlined,
      path: ROUTE_PATHS.DASHBOARD2,
      status: "in progress",
    },
    {
      label: "Тўғридан тўғри инвестициялар",
      icon: RiseOutlined,
      path: ROUTE_PATHS.DIRECT,
      status: "in progress",
    },
    {
      label: "ХМИ лойиҳалар",
      icon: GlobalOutlined,
      path: ROUTE_PATHS.INTERNATIONAL,
      status: "in progress",
    },
    {
      label: "Стратегик лойиҳалар",
      icon: PieChartOutlined,
      path: ROUTE_PATHS.STRATEGIC,
      status: "in progress",
    },
  ];

  return (
    <aside
      className={twMerge(
        "flex h-screen flex-col transition-all duration-300",
        isSidebarOpen ? "w-[200px] 2xl:w-[230px]" : "w-14",
      )}
    >
      <div className="sticky top-0 z-10 flex items-center justify-between bg-[#fff] p-[20px]">
        <button onClick={toggleSidebar} aria-label="Toggle Sidebar">
          <HamburgerIcon className="text-2xl text-[#B7BFD5]" />
        </button>
      </div>

      {!isSidebarOpen && <Divider className="m-0" />}

      <nav className="flex-1 overflow-y-auto bg-transparent">
        <ul className={twMerge("space-y-2", isSidebarOpen ? "p-3" : "p-2")}>
          {adminItems.map((item, i) => {
            return (
              <SidebarItem
                key={`routes-${i}`}
                item={item}
                isSidebarOpen={isSidebarOpen}
              />
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
